import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';

@Component({
    selector: 'app-settings-row',
    standalone: true,
    imports: [TranslatePipe],
    template: `
        <div class="row align-items-center py-2">
            <div class="col-md-8">
                <ng-content />
            </div>
            <div class="col-md-4 text-muted small">
                {{ hintKey() | translate: 'online' : 'export' }}
                <ng-content select="[hint-extra]" />
            </div>
        </div>
    `,
    styles: `
        :host {
            display: block;
        }

        :host(:not(:first-child)) {
            border-top: 1px solid var(--bs-border-color);
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsRowComponent {
    readonly hintKey = input.required<string>();
}
